import { ClientDataType, ClientSplitRule } from '../utils/DataTypes';

export const truncateClientName = (name: string): string => {
  const suffixesRegex = /\s*,?\s*(LLC|INC|DBA|LTD|CORP|LLP|LP)\.?$/i;
  return name.replace(suffixesRegex, '').trim();
};

export const EMPTY_SPLIT_RULE: ClientSplitRule = {
  fieldToSplit: '',
  sourceField: '',
  conditionLength: '',
  leftTrim: '',
  rightTrim: '',
  matchValue: '',
  newClientName: '',
  newClientNumber: '',
  identifierType: undefined,
  identifierValues: [],
};

export function debounce(fn: (...args: any[]) => void, delay: number) {
  let timeout: any;
  return (...args: any[]) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), delay);
  };
}

export const normalizeRules = (rules: ClientSplitRule[], primaryClient: ClientDataType): ClientSplitRule[] => {
  return rules.map((rule, index) => {
    const isAutoNumbered = rule.newClientNumber.startsWith(primaryClient.client_number);

    if (isAutoNumbered) {
      return {
        ...rule,
        newClientName: rule.newClientName,
        newClientNumber: rule.newClientNumber,
      };
    }
    return rule;
  });
};
export const applyTrim = (value: any, rule: ClientSplitRule) => {
  if (value === null || value === undefined) return '';

  // 1. Ensure we are working with a clean string
  let result = String(value).trim();

  const minLen = Number(rule.conditionLength || 0);
  const left = Number(rule.leftTrim || 0);
  const right = Number(rule.rightTrim || 0);

  // 2. Minimum Length Guard (Skip transformation if too short)
  if (result.length < minLen) return result;

  // 3. Apply Left Trim (Take the first X characters)
  if (left > 0) {
    result = result.substring(0, left);
  }

  // 4. Apply Right Trim (Take the last X characters from the remaining string)
  if (right > 0) {
    result = result.slice(-right);
  }

  return result;
};

export const formatDate = (value: any) => {
  if (!value) return '';
  const timestamp = typeof value === 'string' ? parseInt(value, 10) : value;
  const date = new Date(timestamp);
  return isNaN(date.getTime()) ? '' : date.toISOString().split('T')[0];
};

export const formatSplitTypes = (type: string) => {
  switch (type) {
    case 'split':
      return 'Client Bill split';
    case 'combine':
      return 'Client Bill Combine';
    case 'tpa':
      return 'TPA Change';
    case 'cleanup':
      return 'General Data Clean-up';
      return type;
  }
};

const FORBIDDEN_KEYWORDS = ['delete', 'drop', 'truncate', 'alter', 'insert', 'create', 'grant', 'revoke', 'select'];

export function validateCustomSql(sql: string): string | null {
  const trimmed = sql.trim();
  const normalized = sql.trim().toLowerCase();

  if (!normalized.includes('{{table}}')) {
    return 'You must use the {{TABLE}} placeholder. Real table names are not allowed.';
  }

  if (!normalized.startsWith('update {{table}}')) {
    return 'SQL must start exactly with "UPDATE {{TABLE}}"';
  }

  if (!trimmed.endsWith(';')) {
    return 'SQL statement must end with a semicolon (;).';
  }

  if (normalized.includes(';')) {
    if (trimmed.indexOf(';') !== trimmed.length - 1) {
      return 'Semicolons are only allowed at the very end of the statement.';
    }

    const count = (normalized.match(/;/g) || []).length;
    if (count > 1) {
      return 'Multiple SQL statements are not allowed.';
    }
  }

  for (const word of FORBIDDEN_KEYWORDS) {
    if (normalized.includes(word + ' ')) {
      return `Keyword "${word.toUpperCase()}" is strictly prohibited for safety.`;
    }
  }

  return null;
}
